import { Autocomplete, TextField } from '@mui/material'
import { CustomersQuery } from '@kistill/client/data-access'

interface CustomerChipProps {
  data: CustomersQuery | undefined
}

export function CustomerChip({ data }: CustomerChipProps) {
  const options = data?.customers?.map((option) => {
    const firstLetter = option.name[0].toUpperCase()
    return {
      firstLetter: /[0-9]/.test(firstLetter) ? '0-9' : firstLetter,
      ...option,
    }
  })

  return (
    <Autocomplete
      multiple
      size='small'
      id='adilar'
      renderInput={(params) => <TextField {...params} label='Aðilar' />}
      groupBy={(option) => option.firstLetter}
      getOptionLabel={(option) => option.name}
      isOptionEqualToValue={(customers, options) =>
        customers?.name === options.name
      }
      options={[
        ...(options
          ?.map((x) => ({
            name: x.name,
            firstLetter: x.firstLetter,
          }))
          .sort((a, b) => -b.firstLetter.localeCompare(a.firstLetter)) ?? []),
      ]}
    />
  )
}
export default CustomerChip
